import { render, staticRenderFns } from "./other-fee.vue?vue&type=template&id=36b40c7c&scoped=true"
import script from "./other-fee.vue?vue&type=script&lang=js"
export * from "./other-fee.vue?vue&type=script&lang=js"
import style0 from "./other-fee.vue?vue&type=style&index=0&id=36b40c7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b40c7c",
  null
  
)

export default component.exports